/**
 * Scroll helpers that land a target flush below the fixed header.
 * The header height is measured live so mobile (~68px) and desktop (~80px)
 * both work without hardcoded magic numbers.
 */

export function getHeaderOffset(): number {
  if (typeof document === 'undefined') return 0;
  const header = document.querySelector('header');
  return header ? Math.ceil(header.getBoundingClientRect().height) : 0;
}

export function scrollToElement(
  el: Element,
  behavior: ScrollBehavior = 'smooth',
) {
  const rect = el.getBoundingClientRect();
  const top = rect.top + window.scrollY - getHeaderOffset();
  window.scrollTo({ top: Math.max(0, top), behavior });
}

export function scrollToHash(hash: string, behavior: ScrollBehavior = 'smooth') {
  const id = hash.startsWith('#') ? hash.slice(1) : hash;
  const el = document.getElementById(id);
  if (el) scrollToElement(el, behavior);
  return !!el;
}
